import { useEffect, useState } from 'react'
import { useLocation }      from 'react-router-dom'
import { active_project, currentActiveProject, current_language, fullViewMode, isMulti_project_active, vis_list }   from 'state/store.global'
import { _bootstrap }       from 'state/store.bootstrap'
import { _project }         from 'state/store.projects'
import { getFocus, useAtom, useSet } from 'state/jotai'

export const useSetActiveProject = () => {

  const [ res, setRes ] = useState(false)
  const setMultiActive = useAtom(isMulti_project_active)[1];
  const multiActive = useAtom(isMulti_project_active)[0];

  const type     = getFocus(_bootstrap, 'type')
  const location = useLocation().pathname
  const names    = getFocus(_bootstrap, 'projectnames')
  const languages    = getFocus(_bootstrap, 'languages')
  const ids      = getFocus(_bootstrap, 'projectids')

  const [currentLanguage, setCurrentLanguage] = useAtom(current_language);
  const activeProject = useAtom(currentActiveProject)[0];
  const setActiveProject = useAtom(currentActiveProject)[1];
  const setActiveID  = useSet(active_project)
  const [, setShowList] = useAtom(vis_list);
  const viewMode = useAtom(fullViewMode)[0];

  useEffect(()=>{
    if ( location && type === "poly") {
      const loc      = location.split('/')
      const language = languages.filter( l => l === loc[1])[0] ?? currentLanguage
      const currentActiveProjectURL = location.split('/')[3]

      const currentProject = ['', "isometry"].includes(activeProject) ? currentActiveProjectURL : activeProject;
      
      const findActiveProject = names[language]?.filter((lan) => lan?.Presentation === currentProject);
      // const currentActiveProject = findActiveProject?.length ? findActiveProject?.[0] : names[language]?.[0]
      let currentActiveProject = findActiveProject?.length
      ? findActiveProject[0]
      : names[language]?.[0];
      if (currentActiveProject?.PIN > 4) {
        navigateTo(`/${language}${names[language]?.[0].path}`);
      }
      
      setActiveProject(currentProject)
      
    currentActiveProject =
      currentActiveProject?.PIN > 4
        ? names[language]?.[0]
        : currentActiveProject;


      const pin =  currentActiveProject?.PIN
      const pid = currentActiveProject?.PID
     
      // console.log(pin,pid,"pinpid")
      if(language) setCurrentLanguage(language);
      if(pin > 0 ) setMultiActive(true) 
      else setMultiActive(false) 
      if(!multiActive) setActiveID({ pid, pin })

      
      // split view code

      const shouldShow = type === "poly" && pin > 0 && viewMode === 'split';

      if (shouldShow) {
        setShowList(true);
      }
      else {
        setShowList(false)
      }

      setRes(true)
    }else {
      setActiveID({ pid: ids[0], pin: 0 })
      setMultiActive(true)
    }
  },[location, currentLanguage, multiActive])

  return res

}